import config from "./config";
const { ajax_url } = config;
import axios from "axios";

var service = axios.create({
  baseURL: ajax_url,
  timeout: 5000,
});

//添加请求拦截器
service.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
//添加响应拦截器
service.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    console.log("err" + error);
    // Toast("网络不佳,请稍后重试");
    return Promise.reject(error);
  }
);

export default {
  //get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params: param,
        withCredentials: true,
        crossDomain: true,
      })
        .then((res) => {
          //axios返回的是一个promise对象
          resolve(res); //resolve在promise执行器内部
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  //post请求
  post(url, param, token) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url: url,
        data: param,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          token: token ? token : localStorage.getItem("qz_zyz_token"),
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
};
